import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import api from '../../connection/Axios';
import { Link } from 'react-router-dom';


const ListarEmpresas = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [companies, setCompanies] = useState([])
  const [techUsers, setTechUsers] = useState([])

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

  
    async function GetCompanies() {
      api.get('company/getCompanies/', headers).then(response => {
        setCompanies(response.data.filter(user => user.companyId === companies?.cnpj))
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }


    useEffect(()=>{
      GetCompanies()
    }, [])


    async function DeleteCompany(cnpj) {
      await api.post('company/deleteCompany', {cnpj: cnpj}, headers).then(response => {
        GetCompanies()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, typeError: 'error'})
      })
    }
    

    return (
      <>
          <Layout breadcrumb='Dashboard / Empresas / Listar Empresas' title='Listar Empresas'>
          <Typography>Empresas cadastradas no sistema EHS</Typography>
            <br />
            <div style={styles.list}>
              {companies?.map((comp, index)=>(
                <>
                <div key={index} className='listItem' >
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={({marginBottom: 10, fontSize: 15, fontWeight: 600})}>
                      {comp.nomeFantasia}
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                      <Button variant="outlined" disableElevation color="secondary" size='small' component={Link} to="/editar-empresa" state={{data: comp}}>Editar</Button>&nbsp;&nbsp;
                      <Button variant="outlined" disableElevation color="error" size='small' onClick={()=>{DeleteCompany(comp.cnpj)}}>Remover</Button>
                    </div>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{fontSize: 13, fontWeight: 600, width: 100}}>
                      CNPJ:
                    </div>
                    <div style={{fontSize: 13}}>
                      {comp.cnpj}
                    </div>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{fontSize: 13, fontWeight: 600, width: 100}}>
                      Endereço:
                    </div>
                    <div style={{fontSize: 13}}>
                      {comp.rua}, {comp.numero} {comp.complemento}<br />
                      {comp.bairro} - {comp.cidade} / {comp.uf}
                    </div>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{fontSize: 13, fontWeight: 600, width: 100}}>
                      CEP:
                    </div>
                    <div style={{fontSize: 13}}>
                      {comp.cep}
                    </div>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{fontSize: 13, fontWeight: 600, width: 100}}>
                      Contato:
                    </div>
                    <div style={{fontSize: 13}}>
                       {comp.telefone}{comp.adminUser != undefined ? ` - ${comp.adminUser}` : null}
                    </div>
                  </div>
                </div>
              </>
              ))}
            </div>
          </Layout>
      </>
    );
}

export default ListarEmpresas

const styles = {
  list: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 20
  }
}